// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Cases__Wrapper_oDpet","Projects":"Cases__Projects_WFM1u grid"};